var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExchange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#64B5F6",
    d: "M40,13H25v22h15c1.104,0,2-0.896,2-2V15C42,13.896,41.104,13,40,13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M39,18.243v0.7v1.742c0,0.141,0,0.377-0.141,0.498l-1.82,1.819c-0.139,0.141-0.28,0.141-0.42,0l-0.699-0.56c-0.141-0.14-0.141-0.28,0-0.42l0.839-0.84l0,0v-2.94h-2.52c-2.24,1.68-4.06,4.76-4.62,4.2c-0.699-0.561,3.641-6.3,4.199-6.44h2.94h1.82c0.28,0,0.421,0.141,0.421,0.421V18.243L39,18.243z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M36.76,32h-0.7h-1.742c-0.141,0-0.377,0-0.498-0.141L32,30.039c-0.141-0.14-0.141-0.28,0-0.42l0.56-0.7c0.14-0.141,0.28-0.141,0.42,0l0.84,0.84l0,0h2.94v-2.52c-1.68-2.24-4.76-4.061-4.2-4.62c0.561-0.7,6.3,3.641,6.44,4.199v2.94v1.82C39,31.859,38.859,32,38.579,32H36.76L36.76,32z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M23.543,29.76v-0.7v-1.742c0-0.141,0-0.377,0.141-0.498L25.504,25c0.139-0.141,0.28-0.141,0.42,0l0.699,0.56c0.141,0.14,0.141,0.28,0,0.42l-0.839,0.84l0,0v2.94h2.52c2.24-1.68,4.06-4.76,4.62-4.2c0.699,0.561-3.641,6.3-4.199,6.44h-2.94h-1.82c-0.28,0-0.421-0.141-0.421-0.421V29.76L23.543,29.76z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M25.783,16.003h0.7h1.742c0.141,0,0.377,0,0.498,0.141l1.819,1.82c0.141,0.14,0.141,0.28,0,0.42l-0.56,0.7c-0.14,0.141-0.28,0.141-0.42,0l-0.84-0.84l0,0h-2.94v2.52c1.68,2.24,4.76,4.061,4.2,4.62c-0.561,0.7-6.3-3.641-6.44-4.199v-2.94v-1.82c0-0.28,0.141-0.421,0.421-0.421H25.783L25.783,16.003z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E88E5",
    d: "M27 42L6 38 6 10 27 6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M20,32.813l-8-0.701V16.809l7.72-0.836v3.083l-4.771,0.283v3.511l4.352-0.139v3.082h-4.352v3.655L20,29.728V32.813z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExchange);
export default __webpack_public_path__ + "static/media/icon-exchange.751820f9ac6094954051d6586b7e1f07.svg";
export { ForwardRef as ReactComponent };